import { Link } from 'react-router-dom';
import { formatDateRange, formatGuests } from '../../utils/bookingUtils';

const CartHeader = ({ bookingId, checkIn, checkOut, nights, guests, title = 'Cart', bookingLabel = 'Booking' }) => {
  const metaParts = [];
  const dateLabel = formatDateRange(checkIn, checkOut);
  if (dateLabel) metaParts.push(dateLabel);
  if (nights) metaParts.push(`${nights} night${nights === 1 ? '' : 's'}`);
  if (guests) metaParts.push(formatGuests(guests));

  return (
    <div className="flex flex-col gap-4">
      <nav className="text-xs uppercase tracking-[0.22em] text-slate-500">
        <Link to="/" className="hover:text-slate-700">
          Home
        </Link>
        <span className="mx-2 text-slate-300">/</span>
        <Link to="/listings" className="hover:text-slate-700">
          Stays
        </Link>
        <span className="mx-2 text-slate-300">/</span>
        <span className="text-slate-700">{title}</span>
      </nav>
      <div className="rounded-2xl border border-[#E7DED4] bg-white/90 p-5 shadow-[0_12px_30px_rgba(15,23,42,0.08)]">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-slate-500">{bookingLabel}</p>
            <p className="text-2xl font-semibold text-slate-900">
              {bookingId ? `#${bookingId}` : 'Draft booking'}
            </p>
          </div>
          {metaParts.length > 0 && (
            <div className="text-sm text-slate-600">{metaParts.join(' | ')}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CartHeader;
